import {
  Flex,
  Table,
  TableCaption,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { BLUEMONEDDBUTTONS, WHITE } from "../../../../constants/colors";
import moment from "moment";
import { simplifiedExtract } from "../../../../interfaces/defaultInterfaces";
import { useEffect, useState } from "react";
import { ToLocaleFormat } from "../../../../defaultFunctions/formaters";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function TableSalesSuccess({ data, title }: any) {
  const [salesCredit, setSalesCredit] = useState(Array<simplifiedExtract>);
  useEffect(() => {
    setSalesCredit(data);
  }, [data]);
  const colors = useRecoilState(customColors)[0];

  return (
    <>
      {salesCredit.length && (
        <Flex w={"100%"} flexDirection={"column"} mt={4}>
          <Text m={4} fontSize={"16px"} fontWeight={"bold"}>
            {title}
          </Text>
          <Table variant={"striped"}>
            <TableCaption fontWeight={"bold"}>
              Total:{" "}
              {ToLocaleFormat(salesCredit.reduce((acc, i) => acc + i.valor, 0))}
            </TableCaption>
            <Thead
              h="60px"
              position="sticky"
              top="0"
              bgColor={colors.BLUEMONEDDBUTTONS}
            >
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Data da Venda
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Data do Pagamento
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Id da Transação
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Bandeira
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  N° da Parcela
                </Th>
                {data[0]?.tipoLancamento.lancamento === "Chargeback" ||
                data[0]?.tipoLancamento.lancamento === "Venda Disputa" ? (
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data do Movimento
                  </Th>
                ) : (
                  <></>
                )}
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Valor da Transação
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Taxa
                </Th>
                {/* <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>Tarifa</Th> */}
                <Th
                  borderRadius={"0 8px 8px 0"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Valor Líquido
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {salesCredit &&
                salesCredit.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td borderRadius={"8px 0 0 8px"}>
                        {moment(item?.transacao?.dataCriacao).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      {/* <Td>
                        {moment(item?.transacao?.dataPagamento).format(
                          "DD/MM/YYYY"
                        )}
                      </Td> */}
                      <Td>
                        {moment(item?.dataLancamento).format("DD/MM/YYYY")}
                      </Td>
                      <Td>{item?.transacao?.idTransacao}</Td>
                      <Td>{item?.transacao?.bandeira?.bandeira}</Td>
                      {/* <Td>{item?.nroParcelas ? item?.nroParcelas : 1}</Td> */}
                      <Td fontSize="12px">
                        {item.parcela
                          ? `${item.parcela}/${item.nroParcelas}`
                          : ``}
                      </Td>
                      {data[0]?.tipoLancamento.lancamento === "Chargeback" ||
                      data[0]?.tipoLancamento.lancamento === "Venda Disputa" ? (
                        <Td>
                          {moment(item.dataLancamento).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </Td>
                      ) : (
                        <></>
                      )}
                      <Td>
                        {item.nroParcelas > 1 && item.parcela !== null
                          ? ToLocaleFormat(
                              item.transacao.valor / item.nroParcelas
                            )
                          : ToLocaleFormat(item?.transacao?.valor)}
                      </Td>
                      <Td>
                        {item.nroParcelas > 1 && item.parcela !== null
                          ? ToLocaleFormat(
                              item.transacao.taxaCliente / item.nroParcelas
                            )
                          : ToLocaleFormat(item?.transacao?.taxaCliente)}
                      </Td>
                      <Td>{ToLocaleFormat(item?.valor)}</Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Flex>
      )}
    </>
  );
}
